<template>
  <a-modal
    title="供应商一级分类"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
    width="550px"
  >
    <a-form layout="inline" :form="dataForm" @submit="getDataList">
      <a-form-item label="分类名称">
        <a-input
          v-model="dataForm.categorize_name"
          placeholder="分类名称"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="addOrUpdateHandle()"
          >新增分类</a-button
        >
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :data-source="dataList"
      rowKey="id"
      :loading="dataListLoading"
      :pagination="false"
    >
      <template slot="editBtn" slot-scope="text, row">
        <a-button
          type="link"
          class="btn-edit"
          @click="addOrUpdateHandle(row.categorize_id)"
        >
          编辑
        </a-button>
        <a-button
          type="link"
          class="btn-edit"
          @click="deleteHandle(row.categorize_id)"
        >
          删除
        </a-button>
      </template>
    </a-table>
    <a-pagination
      :current="page"
      :total="total"
      :show-total="(total) => `共 ${total} 条数据`"
      @showSizeChange="showSizeChange"
      @change="pageCurrentChangeHandle"
      size="small"
      class="mt-10 ml-20"
    />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-modal>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdatecate.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: "/admin/suppliercategorize/page",
        deleteURL: "/admin/suppliercategorize/delete",
      },
      dataForm: {
        supplier_id: "",
        categorize_name: "",
      },
      columns: [
        {
          title: "供应商名称",
          dataIndex: "supplier.supplier_name",
        },
        {
          title: "分类名称",
          dataIndex: "categorize_name",
          scopedSlots: { customRender: "categorize_name" },
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 100,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    init(supplier_id) {
      this.dataForm.supplier_id = supplier_id;
      this.visible = true;
      this.getDataList();
    },
    handleOk() {
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
    },
    addOrUpdateHandle(categorize_id) {
      this.$refs.addOrUpdate.init(categorize_id, this.dataForm.supplier_id);
    }
  },
};
</script>

<style>
</style>